import { useState, useEffect, useCallback } from 'react';

export default function useSessionStorage(key, defaultValue) {
  const [value, setValue] = useState(() => {
    try {
      const storedValue = window.sessionStorage.getItem(key);
      return storedValue === null ? defaultValue : JSON.parse(storedValue);
    } catch (error) {
      console.error(`Error reading sessionStorage key “${key}”:`, error);
      return defaultValue;
    }
  });

  useEffect(() => {
    const listener = (e) => {
      if (e.storageArea === window.sessionStorage && e.key === key) {
        try {
          setValue(JSON.parse(e.newValue));
        } catch (error) {
          console.error(`Error parsing new value for sessionStorage key “${key}”:`, error);
        }
      }
    };
    window.addEventListener('storage', listener);
    return () => {
      window.removeEventListener('storage', listener);
    };
  }, [key]);

  const setValueInSessionStorage = useCallback(
    (newValue) => {
      setValue((currentValue) => {
        const result = typeof newValue === 'function' ? newValue(currentValue) : newValue;
        try {
          window.sessionStorage.setItem(key, JSON.stringify(result));
        } catch (error) {
          console.error(`Error setting sessionStorage key “${key}”:`, error);
        }
        return result;
      });
    },
    [key]
  );

  return [value, setValueInSessionStorage];
}
